import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { Page } from './Page';

export class PublicPage extends Page {
    public static normatives: { [key: string]: string } = {
        'normativa-guantes-776': 'region-normative-en-388-2016',
        'normativa-guantes-1452': 'region-normative-en-407-2020',
        'normativa-guantes-42': 'region-normative-en-407-2004',
        'normativa-guantes-834': 'region-normative-en-374-2016',
        'normativa-guantes-44': 'region-normative-en-511-2006',
    }

    public static render(params: RouteParams): void {
        PublicPage._initComparative();
        PublicPage._initFilters();
    }

    protected static _OpenMenu() {
        const navbar_toggler = $('.navbar-toggler');
        const header_store_left = $('.header_store_left');
        const menuHeader = $('.menuHeader');

        navbar_toggler.on("click", function () {
            header_store_left.addClass("open");
        });

        menuHeader.on("click", function () {
            header_store_left.removeClass("open");
        });

        const menu_expanded = $('.menu-item--expanded');
        menu_expanded.on("click", function () {
            $(this).toggleClass("open");
        })
    }

    private static _initComparative(): void {
        const comparativeBlock = $('.comparative_block');
        if (comparativeBlock.length == 0) {
            return;
        }

        const isNodePage = drupalSettings.node !== undefined;
        const minChecked = (isNodePage) ? 1 : 2;

        const getItemTemplate = ({ img = '', title = '', subtitle = '' }: any) => {
            return `
                <div class="product">
                    <div class="image">${img}</div>
                    <div class="text">
                        <div class="title">${title.trim()}</div>
                        <div class="subtitle">${subtitle.trim()}</div>
                    </div>
                </div>
            `;
        }

        const comparativeProducts = comparativeBlock.find('.products');
        const comparativeBtn = comparativeBlock.find('.button');
        const initialText = comparativeProducts.html();

        $('.check_comparative').on('click', (e) => {
            const target = $(e.target);
            const article = target.closest('article');

            article.toggleClass('comparative-checked', target.is(':checked'));

            const items = new Array();
            const articleChecked = $('article.comparative-checked');

            if (articleChecked.length < minChecked) {
                comparativeProducts.html(initialText);
                comparativeBtn.attr('href', '');

                return;
            }

            let html = '';
            if (isNodePage) {
                const nodeContainer = $('#main article.full');
                const textContainer = nodeContainer.find('.file__heading__text');
                html += getItemTemplate({
                    img: `<img src="${nodeContainer.find('#images-slider').attr('data-image')}" />`,
                    title: textContainer.find('.title').text(),
                    subtitle: textContainer.find('.short-description').text(),
                });

                items.push(`id[0]=${drupalSettings.node.nid}`);
            }

            articleChecked.each((index, element) => {
                const item = $(element);

                const title = item.find('.views-field-title');

                html += getItemTemplate({
                    img: item.find('img')?.get(0)?.outerHTML,
                    title: title.text(),
                    subtitle: item.find('.views-field-field-nombre').text(),
                });

                let currentIdx = index;
                if (isNodePage) {
                    currentIdx++;
                }

                const nid = item.attr('data-history-node-id');
                items.push(`id[${currentIdx}]=${nid}`);
            })

            comparativeProducts.html(html);
            comparativeBtn.attr('href', `/${drupalSettings.path.pathPrefix}comparativa?${items.join('&')}`);
        });

        comparativeBlock.on('click', '.label', (e) => {
            const block = $(e.target).closest('.block-jubappe-blocks-comparative');
            const list = block.find('.list_products');

            if (block.hasClass('open')) {
                list.removeClass('open');
                setTimeout(() => {
                    block.removeClass('open');
                }, 800);

                return;
            }

            list.addClass('open');
            block.addClass('open');
        });
    }

    private static _initFilters(): void {
        const body = $('body');
        if (body.find('.view_header_facets').length === 0
            || body.find('.open_facets').length === 0
            || body.find('.close_facets').length === 0
        ) {
            return;
        }

        PublicPage._openFilters();
        PublicPage._activeFilters();
    }

    private static _openFilters(): void {
        $('.open_facets').on('click', () => $('.facets').addClass('open'));
        $('.close_facets').on('click', () => $('.facets').removeClass('open'));
    }

    private static _activeFilters(): void {
        const facetsClass = [
            'guantes-de-trabajo',
            'clothing',
            'taxonomy-terms-nodes-search',
	        'store-gloves-search-api',
            'store-clothes-search-api'
        ];

        let facets: any;
        for (const i of facetsClass) {
            facets = $(`.view-${i}__header__facets`);
            if (facets.length > 0) {
                break;
            }
        }

        if (facets.length == 0) {
            return;
        }

        let exist_facets_active = false;

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {

                if (mutation.type === 'childList' && !exist_facets_active) {

                    const facets_actives = facets.find('.facet-active .is-active');
                    if (facets_actives.length == 0) {
                        return;
                    }

                    exist_facets_active = true;
                    const active_filters = $('<div></div>');
                    active_filters.addClass('active-filters');

                    facets_actives.each(function () {
                        const item = $(this);
                        const filter = $('<p></p>');
                        filter.addClass('active-filter');

                        const link = $('<a></a>');
                        link.attr('href', item.attr('data-href') ?? '');

                        let text = item.find('.facet-item__value').text();
                        const atribute = item.find('.facet-item__value').attr('data-drupal-facet-item-id');
                        if (PublicPage.normatives.hasOwnProperty(atribute!)) {
                            link.removeAttr('href');
                            filter.on('click', () => {
                                PublicPage._showModal(PublicPage.normatives[atribute!], item.get(0) as HTMLElement);
                            });
                        }
                        link.html(text);

                        filter.append(link);
                        active_filters.append(filter);
                    });

                    const delete_filters = $('<p></p>');
                    delete_filters.addClass('delete-filters');
                    const link_delete = $('<a></a>');
                    const url = new URL(window.location.href);
                    url.search = "";
                    link_delete.attr("href", url.href);
                    link_delete.text(Drupal.t('Borrar'));
                    delete_filters.append(link_delete);
                    active_filters.append(delete_filters);

                    facets.after(active_filters);
                }
            }
        });

        observer.observe(facets.closest('[class$="__header"]')[0], {
            childList: true,
            subtree: true
        });
    }

    private static _showModal(normative: string, checkbox: HTMLElement) {
        Drupal.behaviors.juba.openModal(normative, checkbox);
        $('#btnNormative').trigger('click');
        const modalSections = $('#modalNormative .modal-body section');
        modalSections.css({ 'display': 'none' });
        setTimeout(() => {
            modalSections.filter(`[class*="${normative}"]`).css({ 'display': 'grid' });
        }, 100);
    }
}
